import React from 'react';

import { SectionWrapper, Icon } from './styles';

import image from '../../assets/illustrations/winners.svg';

function Section() {
    return (
        <SectionWrapper>
            <figure>
                <img src={image} alt="" />
            </figure>
            <section>
                <h1>How do you get top ranks in SEO?</h1>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Praesentium molestias dolorem nihil quis consectetur in, voluptatem inventore saepe impedit. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est, eius.</p>

                <h2>
                    <Icon />
                    Watch video
                </h2>
            </section>

        </SectionWrapper>
    );
}

export default Section;